import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';

import UploadField from 'components/fields/UploadField';
import TextField from 'components/fields/TextField';
import IconButton from 'components/common/IconButton';
import IconSave from 'components/icons/IconSave';
import Chip from 'components/common/Chip';

import { createPatientMessageTemplate } from 'redux/modules/patientsMessagesTemplates';

const styles = theme => ({
  chip: {
    position: 'absolute',
    left: 8,
    bottom: 8,
    maxWidth: 'calc(100% - 16px)',
  },
  textField: {
    boxSizing: 'border-box',
    paddingRight: 72,
  },
  textFieldWithFile: {
    paddingBottom: 44,
  },
  iconButton: {
    position: 'absolute',
    right: 46,
    top: -2,
  },
});

const NotificationsDialogMessageDocumentFields = ({ name, classes, submit, Document, Message, actions, account }) => {
  return (
    <Field
      id="Document"
      name="Document"
      component={UploadField}
      placeholder="File Name"
      fullWidth
      variant="container"
      renderContent={(input, acceptClassName) => (
        <Fragment>
          <Field
            inputRootClassName={classNames(classes.textField, acceptClassName, {
              [classes.textFieldWithFile]: Document.input && Document.input.value && Document.input.value.name,
            })}
            id="Message"
            name="Message"
            placeholder="Write message or drag file here and press Ctrl + Enter to send"
            component={TextField}
            fullWidth
            multiline
            maxLength="524288"
            onKeyDown={(event) => {
              if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
                submit();
              }
            }}
          />
          {(Message.input && Message.input.value && Message.input.value.length > 0) &&
            <IconButton
                className={classes.iconButton}
                onClick={() => {
                  actions.createPatientMessageTemplate({
                    values: {
                      'User ID': account.ID,
                      Content: Message.input.value,
                    },
                  });
                }}
                tooltipContent="Save as template"
              >
              <IconSave className={classes.iconSave} />
            </IconButton>
          }
          {(Document.input && Document.input.value && Document.input.value.name) &&
            <Chip
              className={classes.chip}
              size="md"
              square
              label={Document.input.value.name}
              onDelete={() => {
                Document.input.onChange('');
              }}
            />
          }
        </Fragment>
      )}
    /> 
  );
};

NotificationsDialogMessageDocumentFields.propTypes = {
  account: PropTypes.shape({
    ID: PropTypes.number,
  }),
  submit: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    createPatientMessageTemplate: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    chip: PropTypes.string.isRequired,
    textFieldWithFile: PropTypes.string.isRequired,
  }).isRequired,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ createPatientMessageTemplate }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(NotificationsDialogMessageDocumentFields),
);



// WEBPACK FOOTER //
// ./src/components/patient/NotificationsDialog/NotificationsDialogMessageDocumentFields.js